import React, { Component } from "react";
import $ from "jquery";
import store from "store";
import Page from "../Page";
import { Button } from "react-materialize";
import {
	API_PAYMENT_METHOD,
	API_PAYMENT,
	API_VOUCHER,
	FormatPrice,
	CheckAuth,
	scrollToTop
} from "../Util";
import { notify } from "react-notify-toast";
import TransactionConstants from "../Transaction/Constants";
import "../../styles/new-style.css";

class Payment extends Page {
	constructor(props) {
		super(props);

		this.state = {
			data: "",
			itemType: "",
			inputVoucher: "",
			voucherData: "",
			participantData: "",
			paymentMethodData: null,
			selectedPaymentMethod: null,
			selectedBankUid: null,
			selectedBankVACode: null
		};
	}

	componentDidMount = () => {
		let locationState = this.props.location.state;

		if (locationState && CheckAuth()) {
			this.loadPaymentMethod()

			if (locationState.itemType) {
				if (locationState.itemType == "event") {
					let participantLength =
						locationState.data.item_data.participants.length;
					locationState.data.title += " x " + participantLength;
					locationState.data.price *= participantLength;
				}

				this.setState(
					{
						data: locationState.data,
						itemType: locationState.itemType,
						participantData: locationState.data.item_data
							? locationState.data.item_data.participants
							: ""
					},
					() => {
						console.log("DATA >>> ", this.state.data);
						console.log("ITEM TYPE >>> ", this.state.itemType);
					}
				);
			} else {
				notify.show("Item type tidak ditemukan", "warning");
			}
		} else {
			this.props.history.goBack();
		}

		scrollToTop();
	};

	loadPaymentMethod = () => {
		$.get(API_PAYMENT_METHOD).then(result => {
			this.setState({ paymentMethodData: result })
		})
	}

	handleChangeVoucher = e => {
		let { value } = e.target;
		value = value.toUpperCase();
		console.log("ON CHANGE VOUCHER VALUE >>> ", value);
		this.setState({ inputVoucher: value });
	};

	handleCancelVoucher = e => {
		e.preventDefault();
		let { voucherData } = this.state;
		notify.show("Voucher " + voucherData.code + " dibatalkan", "warning");
		this.setState({ voucherData: "" });
	};

	handleSubmitVoucher = e => {
		e.preventDefault();
		let { inputVoucher } = this.state;

		$.get(API_VOUCHER + "/" + inputVoucher)
			.then(data => {
				console.log("handleSubmitVoucher >>> ", data);
				this.setState({ voucherData: data.payload });
			})
			.fail((XMLHttpRequest, textStatus, errorThrown) => {
				var response = null;
				var status = XMLHttpRequest.status;

				try {
					response = JSON.parse(XMLHttpRequest.responseText);
				} catch (e) {}

				if (response && response.status) {
					if (response && response.message) {
						notify.show(response.message, "warning");
						this.setState({ errorMessage: response.message });
					} else if (status == 400 || status == 403) {
						this.setState({ errorMessage: response.message });
					} else {
						this.setState({ errorMessage: response.status });
					}
				}
			});
	};

	handleBuy = e => {
		e.preventDefault();
		let { itemType, data, voucherData, participantData } = this.state;
		let itemData = "";
		let voucherCode = voucherData ? voucherData.code : "";

		if (itemType == "event") {
			itemData = JSON.stringify(data.item_data);
		}

		let param = {
			method: this.state.selectedPaymentMethod,
			item_type: itemType,
			item_quantity: participantData.length || 1,
			item_uuid: data.uuid,
			item_data: itemData,
			pin: "000000",
			voucher_code: voucherCode
		};

		// DUMP PARAM
		console.log("ENROLLMENT PARAM >>> ", param);

		$.post(API_PAYMENT, param)
			.then(data => {
				console.log("PAYMENT DATA >>> ", data);
				const { invoice_number } = data.payload;

				this.props.history.push(`/transactions/${invoice_number}`);
			})
			.fail((XMLHttpRequest, textStatus, errorThrown) => {
				var response = null;
				var status = XMLHttpRequest.status;

				try {
					response = JSON.parse(XMLHttpRequest.responseText);
				} catch (e) {}

				if (response && response.status) {
					if (response && response.message) {
						notify.show(response.message, "warning");
						this.setState({ errorMessage: response.message });
					} else if (status == 400 || status == 403) {
						if (this.state.payment_method == TransactionConstants.COUPON) {
							this.setState({ errorMessage: alert.invalid_coupon });
						} else {
							this.setState({ errorMessage: response.message });
						}
					} else {
						this.setState({ errorMessage: response.status });
					}
				}
			});
	};

	render() {
		const {
			data,
			paymentMethodData,
			selectedPaymentMethod,
			selectedBankUid,
			inputVoucher,
			voucherData,
			itemType
		} = this.state;

		let finalPrice = data.price;
		let voucherDeduction = 0;
		let voucherMaxAmount = 0;

		if (voucherData) {
			console.log("Voucher Data >>> ", voucherData);
			voucherMaxAmount = voucherData.max_amount;
			voucherDeduction = finalPrice * (voucherData.discount / 100);
			voucherDeduction =
				voucherDeduction > voucherMaxAmount
					? voucherMaxAmount
					: voucherDeduction;
			finalPrice = finalPrice - voucherDeduction;
		}

		return (
			<div className="container">
				<div className="payment-page">
					<div className="payment-page-top">
						<a
							className="payment-page-top-icon"
							onClick={() => this.props.history.goBack()}
						>
							<i className="material-icons">keyboard_backspace</i>
						</a>
						<span className="strong">Pembayaran</span>
					</div>
					<form autocomplete="off" onSubmit={e => e.preventDefault()}>
						{data.price !== 0 && (
							<section className="payment-input-voucher">
								<form
									className="payment-input-voucher-inner"
									onSubmit={this.handleSubmitVoucher}
								>
									<input
										placeholder="Kode Voucher"
										value={inputVoucher}
										onChange={this.handleChangeVoucher}
										type="text"
									/>
									{voucherData && (
										<Button
											className="btn btn-pa red"
											onClick={this.handleCancelVoucher}
										>
											Batal
										</Button>
									)}
									{!voucherData && (
										<Button className="btn btn-pa">Gunakan</Button>
									)}
								</form>
								{voucherData && (
									<div className="payment-voucher-message font-green">
										{voucherData.title} &nbsp;
										{FormatPrice(voucherDeduction)}
										<br />
									</div>
								)}
								<br />
							</section>
						)}
						<section className="payment-detail">
							<div className="payment-section-title">Detail</div>
							<table>
								<tbody>
									<tr>
										<td>{data.title}</td>
										<td>{FormatPrice(data.price)}</td>
									</tr>
									{voucherData && (
										<tr>
											<td>{voucherData.title}</td>
											<td className="red-text">
												- {FormatPrice(voucherDeduction)}
											</td>
										</tr>
									)}
								</tbody>
								<tfoot>
									<tr>
										<td>Total</td>
										<td className="strong">
											<b>
												{data.price > 0 ? FormatPrice(finalPrice) : "GRATIS"}
											</b>
										</td>
									</tr>
								</tfoot>
							</table>
						</section>
						<br/>
						{/* ================================
              START SELECT PAYMENT METHOD
              ================================ */}
          <form autocomplete="off" onSubmit={this.handleSubmitPayment}>
						<section className="payment-select-method">
							<div className="payment-section-title">Metode Pembayaran</div>
							{!paymentMethodData && <div className="mt-s">Tidak ada metode pembayaran</div>}
							{paymentMethodData &&
								<select onChange={(e) => this.setState({selectedPaymentMethod: e.target.value})}>
									<option value="">-- Pilih Metode Pembayaran --</option>
									{paymentMethodData.map(paymentMethod => (
										<option value={paymentMethod.type}>{paymentMethod.name}</option>
									))}
								</select>
								}
							<br /><br />
						</section>


            <div className="red-text mb-s strong">{this.state.errorMessage}</div>
          </form>
          {/* ================================
              END SELECT PAYMENT METHOD
              ================================ */}
						<Button
							onClick={this.handleBuy}
							id="enroll-btn"
							className="btn btn-pa full-width-buttons"
						>
							Lanjutkan
						</Button>
					</form>
				</div>
			</div>
		);
	}
}

export default Payment;



// WEBPACK FOOTER //
// ./src/components/Payment/Payment.js